module.exports = __webpack_public_path__ + "img/close.ecd07e63.png";